/* ============================================================
   ギフトビルダー（Build a Box）
   WO-001 / 2026-08-27
   ------------------------------------------------------------
   素のJavaScriptのみ。外部ライブラリ・CDNは使わない。
   商品データはLiquidが書き出したDOM（data属性）から読む＝fetch不要。
   文言は sections/roeroe-box-builder.liquid の設定から
   <script type="application/json" data-rr-bab-config> 経由で受け取る。
   ============================================================ */

(function () {
  'use strict';

  var DEFAULT_MONEY_FORMAT = '¥{{amount_no_decimals_with_comma_separator}}';

  /* ---------- 金額の書式（Shopifyの money_format に合わせる） ---------- */

  function groupDigits(value, separator) {
    return value.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + separator);
  }

  function buildAmount(cents, decimals, thousands, decimalMark) {
    var amount = (Number(cents) || 0) / 100;
    var parts = amount.toFixed(decimals).split('.');
    var head = groupDigits(parts[0], thousands);
    return decimals > 0 ? head + decimalMark + parts[1] : head;
  }

  function formatMoney(cents, format) {
    var template = format || DEFAULT_MONEY_FORMAT;
    var match = template.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount_no_decimals_with_comma_separator';
    var value;

    switch (placeholder) {
      case 'amount':
        value = buildAmount(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = buildAmount(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = buildAmount(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = buildAmount(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = buildAmount(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = buildAmount(cents, 0, ' ', '.');
        break;
      case 'amount_with_space_separator':
        value = buildAmount(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = buildAmount(cents, 2, ' ', '.');
        break;
      default:
        value = buildAmount(cents, 0, ',', '.');
    }

    return match ? template.replace(match[0], value) : template + value;
  }

  /* ---------- 小道具 ---------- */

  function fill(template, values) {
    if (!template) return '';
    return String(template).replace(/\{(\w+)\}/g, function (whole, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : whole;
    });
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function extend(target, source) {
    Object.keys(source || {}).forEach(function (key) {
      target[key] = source[key];
    });
    return target;
  }

  /* 1回のビルドを識別する札。箱と中身の全明細に同じ札を付けることで、
     同じお茶でも別のビルド・通常購入とはカート上で合流しなくなる。 */
  function makeBuildId() {
    return 'bab-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 6);
  }

  function readConfig(root) {
    var node = root.querySelector('[data-rr-bab-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      /* 設定JSONが壊れているときは黙って死なせない */
      if (window.console) window.console.error('[rr-bab] 設定JSONを読めませんでした', error);
      return null;
    }
  }

  /* ---------- 本体 ---------- */

  function Builder(root) {
    this.root = root;
    this.config = readConfig(root);
    if (!this.config) return;

    this.strings = this.config.strings || {};
    this.slotCount = Math.max(1, parseInt(this.config.slotCount, 10) || 1);
    this.requireFull = this.config.requireFull !== false;
    this.moneyFormat = this.config.moneyFormat || DEFAULT_MONEY_FORMAT;

    this.stepButtons = toArray(root.querySelectorAll('[data-rr-bab-step-nav]'));
    this.panels = toArray(root.querySelectorAll('[data-rr-bab-panel]'));
    this.boxButtons = toArray(root.querySelectorAll('[data-rr-bab-box]'));
    this.itemNodes = toArray(root.querySelectorAll('[data-rr-bab-item]'));
    this.slotButtons = toArray(root.querySelectorAll('[data-rr-bab-slot]'));
    this.choiceButtons = toArray(root.querySelectorAll('[data-rr-bab-card-choice]'));
    this.cardInputs = toArray(root.querySelectorAll('[data-rr-bab-card-input]'));

    this.slotMessage = root.querySelector('[data-rr-bab-slot-message]');
    this.slotRemaining = root.querySelector('[data-rr-bab-slot-remaining]');
    this.cardFields = root.querySelector('[data-rr-bab-card-fields]');
    this.cardMessage = root.querySelector('[data-rr-bab-card-message]');
    this.totalNode = root.querySelector('[data-rr-bab-total]');
    this.hintNode = root.querySelector('[data-rr-bab-hint]');
    this.errorNode = root.querySelector('[data-rr-bab-error]');
    this.backButton = root.querySelector('[data-rr-bab-back]');
    this.nextButton = root.querySelector('[data-rr-bab-next]');
    this.submitButton = root.querySelector('[data-rr-bab-submit]');

    this.confirmBox = root.querySelector('[data-rr-bab-confirm-box]');
    this.confirmItems = root.querySelector('[data-rr-bab-confirm-items]');
    this.confirmCard = root.querySelector('[data-rr-bab-confirm-card]');
    this.confirmTotal = root.querySelector('[data-rr-bab-confirm-total]');

    this.catalog = {};
    this.boxes = {};
    this.lastStep = this.panels.length ? this.panels.length : 4;

    this.state = {
      step: 1,
      maxStep: 1,
      boxKey: null,
      slots: [],
      cardMode: null,
      submitting: false
    };

    for (var i = 0; i < this.slotCount; i += 1) this.state.slots.push(null);

    this.buildCatalog();
    this.bind();
    this.applyPresets();
    this.render();
  }

  Builder.prototype.readNodeData = function (node) {
    return {
      key: node.getAttribute('data-item-key'),
      variantId: node.getAttribute('data-variant-id'),
      price: parseInt(node.getAttribute('data-price'), 10) || 0,
      title: node.getAttribute('data-title') || '',
      image: node.getAttribute('data-image') || '',
      available: node.getAttribute('data-available') === 'true'
    };
  };

  Builder.prototype.buildCatalog = function () {
    var self = this;

    this.itemNodes.forEach(function (node) {
      var data = self.readNodeData(node);
      if (!data.key) return;
      data.node = node;
      data.countNode = node.querySelector('[data-rr-bab-item-count]');
      self.catalog[data.key] = data;
    });

    this.boxButtons.forEach(function (node) {
      var data = self.readNodeData(node);
      if (!data.key) return;
      data.node = node;
      self.boxes[data.key] = data;
    });

    /* 箱が1つだけなら選ばせず、その箱で確定させる（WO：Step1の縮退） */
    var boxKeys = Object.keys(this.boxes);
    if (boxKeys.length === 1 && this.boxes[boxKeys[0]].available) {
      this.state.boxKey = boxKeys[0];
    }
  };

  Builder.prototype.applyPresets = function () {
    var self = this;
    var presets = this.config.presets || [];
    var slotIndex = 0;

    presets.forEach(function (key) {
      if (slotIndex >= self.slotCount) return;
      var entry = self.catalog[String(key)];
      if (!entry || !entry.available) return;
      self.state.slots[slotIndex] = entry.key;
      slotIndex += 1;
    });
  };

  Builder.prototype.bind = function () {
    var self = this;

    this.stepButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = parseInt(button.getAttribute('data-rr-bab-step-nav'), 10);
        if (!target || target > self.state.maxStep) return;
        self.goTo(target);
      });
    });

    this.boxButtons.forEach(function (button) {
      if (button.hasAttribute('disabled')) return;
      if (button.getAttribute('data-rr-bab-box') === 'static') return;
      button.addEventListener('click', function () {
        var key = button.getAttribute('data-item-key');
        if (!key || !self.boxes[key] || !self.boxes[key].available) return;
        self.state.boxKey = key;
        self.clampProgress();
        self.render();
      });
    });

    this.itemNodes.forEach(function (node) {
      var addButton = node.querySelector('[data-rr-bab-add]');
      if (!addButton) return;
      addButton.addEventListener('click', function () {
        self.addItem(node.getAttribute('data-item-key'));
      });
    });

    this.slotButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = parseInt(button.getAttribute('data-rr-bab-slot'), 10);
        if (isNaN(index)) return;
        if (self.state.slots[index] === null) return;
        self.state.slots[index] = null;
        self.setSlotMessage('');
        self.clampProgress();
        self.render();
      });
    });

    this.choiceButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.state.cardMode = button.getAttribute('data-rr-bab-card-choice');
        self.setCardMessage('');
        self.clampProgress();
        self.render();
      });
    });

    this.cardInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        self.updateCounter(input);
        self.setCardMessage('');
        /* 入力のたびに「次へ」の可否と確認欄を作り直す。
           入力欄そのものは触らないので、打っている最中でも安全（render全体は呼ばない） */
        self.clampProgress();
        self.renderStepper();
        self.renderPanels();
        self.renderConfirm();
        self.renderNav();
      });
    });

    if (this.backButton) {
      this.backButton.addEventListener('click', function () {
        if (self.state.step > 1) self.goTo(self.state.step - 1);
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', function () {
        self.tryAdvance();
      });
    }

    if (this.submitButton) {
      this.submitButton.addEventListener('click', function () {
        self.submit();
      });
    }
  };

  /* ---------- 操作 ---------- */

  Builder.prototype.addItem = function (key) {
    var entry = this.catalog[key];
    if (!entry || !entry.available) return;

    var freeIndex = this.state.slots.indexOf(null);
    if (freeIndex === -1) {
      this.setSlotMessage(this.strings.slotFull || '', true);
      return;
    }

    this.state.slots[freeIndex] = entry.key;
    this.setSlotMessage('');
    this.render();
  };

  Builder.prototype.setSlotMessage = function (text, isAlert) {
    if (!this.slotMessage) return;
    this.slotMessage.textContent = text || '';
    this.slotMessage.hidden = !text;
    this.slotMessage.classList.toggle('rr-bab__message--alert', !!isAlert);
  };

  Builder.prototype.setCardMessage = function (text) {
    if (!this.cardMessage) return;
    this.cardMessage.textContent = text || '';
    this.cardMessage.hidden = !text;
  };

  Builder.prototype.setError = function (text) {
    if (!this.errorNode) return;
    this.errorNode.textContent = text || '';
    this.errorNode.hidden = !text;
  };

  Builder.prototype.filledSlots = function () {
    return this.state.slots.filter(function (key) {
      return key !== null;
    });
  };

  Builder.prototype.cardValues = function () {
    var values = {};
    this.cardInputs.forEach(function (input) {
      values[input.getAttribute('data-field')] = (input.value || '').trim();
    });
    return values;
  };

  Builder.prototype.hasCardText = function () {
    var values = this.cardValues();
    return Object.keys(values).some(function (field) {
      return values[field] !== '';
    });
  };

  Builder.prototype.stepIsSatisfied = function (step) {
    if (step === 1) {
      if (!Object.keys(this.boxes).length) return true; /* 箱が未設定でも進める */
      return !!this.state.boxKey;
    }
    if (step === 2) {
      if (!this.requireFull) return this.filledSlots().length > 0;
      return this.filledSlots().length === this.slotCount;
    }
    if (step === 3) {
      if (!this.state.cardMode) return false;
      if (this.state.cardMode === 'with') return this.hasCardText();
      return true;
    }
    return true;
  };

  Builder.prototype.stepHint = function (step) {
    if (step === 1) return this.strings.boxRequired || '';
    if (step === 2) {
      var remaining = this.slotCount - this.filledSlots().length;
      if (remaining > 0) return fill(this.strings.slotRemaining, { count: remaining });
      return '';
    }
    if (step === 3) {
      if (!this.state.cardMode) return this.strings.cardChoiceRequired || '';
      return this.strings.cardRequired || '';
    }
    return '';
  };

  Builder.prototype.clampProgress = function () {
    for (var step = 1; step < this.state.maxStep; step += 1) {
      if (!this.stepIsSatisfied(step)) {
        this.state.maxStep = step;
        if (this.state.step > step) this.state.step = step;
        return;
      }
    }
  };

  Builder.prototype.tryAdvance = function () {
    if (!this.stepIsSatisfied(this.state.step)) {
      if (this.state.step === 3) this.setCardMessage(this.stepHint(3));
      return;
    }
    if (this.state.step >= this.lastStep) return;
    this.goTo(this.state.step + 1);
  };

  Builder.prototype.goTo = function (step) {
    var target = Math.min(Math.max(step, 1), this.lastStep);
    this.state.step = target;
    if (target > this.state.maxStep) this.state.maxStep = target;
    this.setError('');
    this.render();

    var top = this.root.getBoundingClientRect().top;
    if (top < 0) {
      this.root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  };

  /* ---------- 描画 ---------- */

  Builder.prototype.render = function () {
    this.renderStepper();
    this.renderPanels();
    this.renderBoxes();
    this.renderSlots();
    this.renderItems();
    this.renderCard();
    this.renderConfirm();
    this.renderTotal();
    this.renderNav();
  };

  Builder.prototype.renderStepper = function () {
    var state = this.state;
    this.stepButtons.forEach(function (button) {
      var index = parseInt(button.getAttribute('data-rr-bab-step-nav'), 10);
      var isCurrent = index === state.step;
      button.classList.toggle('is-current', isCurrent);
      button.classList.toggle('is-done', index < state.step);
      button.disabled = index > state.maxStep;
      if (isCurrent) {
        button.setAttribute('aria-current', 'step');
      } else {
        button.removeAttribute('aria-current');
      }
    });
  };

  Builder.prototype.renderPanels = function () {
    var step = this.state.step;
    this.panels.forEach(function (panel) {
      var index = parseInt(panel.getAttribute('data-rr-bab-panel'), 10);
      panel.hidden = index !== step;
    });
  };

  Builder.prototype.renderBoxes = function () {
    var state = this.state;
    this.boxButtons.forEach(function (button) {
      if (button.getAttribute('data-rr-bab-box') === 'static') return;
      var key = button.getAttribute('data-item-key');
      button.setAttribute('aria-checked', key === state.boxKey ? 'true' : 'false');
    });
  };

  Builder.prototype.renderSlots = function () {
    var self = this;

    this.slotButtons.forEach(function (button, index) {
      var key = self.state.slots[index];
      var entry = key ? self.catalog[key] : null;
      var caption = button.parentNode
        ? button.parentNode.querySelector('[data-rr-bab-slot-caption]')
        : null;

      while (button.firstChild) button.removeChild(button.firstChild);

      if (entry) {
        button.classList.add('is-filled');
        button.disabled = false;
        button.setAttribute('aria-label', fill(self.strings.slotFilled, { name: entry.title }));

        if (entry.image) {
          var image = document.createElement('img');
          image.className = 'rr-bab__slot-img';
          image.src = entry.image;
          image.alt = '';
          image.loading = 'lazy';
          button.appendChild(image);
        }

        var remove = document.createElement('span');
        remove.className = 'rr-bab__slot-remove';
        remove.setAttribute('aria-hidden', 'true');
        remove.textContent = '×';
        button.appendChild(remove);

        if (caption) caption.textContent = entry.title;
      } else {
        button.classList.remove('is-filled');
        button.disabled = true;
        button.setAttribute('aria-label', fill(self.strings.slotEmpty, { number: index + 1 }));

        var plus = document.createElement('span');
        plus.className = 'rr-bab__slot-plus';
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '＋';
        button.appendChild(plus);

        if (caption) caption.textContent = '';
      }
    });

    if (this.slotRemaining) {
      var remaining = this.slotCount - this.filledSlots().length;
      this.slotRemaining.textContent =
        remaining > 0 ? fill(this.strings.slotRemaining, { count: remaining }) : this.strings.slotComplete || '';
    }
  };

  Builder.prototype.renderItems = function () {
    var counts = {};
    this.filledSlots().forEach(function (key) {
      counts[key] = (counts[key] || 0) + 1;
    });

    Object.keys(this.catalog).forEach(function (key) {
      var entry = this.catalog[key];
      var count = counts[key] || 0;
      entry.node.classList.toggle('is-picked', count > 0);
      if (entry.countNode) {
        entry.countNode.textContent = count > 1 ? '×' + count : '✓';
        entry.countNode.hidden = count === 0;
      }
    }, this);
  };

  Builder.prototype.renderCard = function () {
    var mode = this.state.cardMode;

    this.choiceButtons.forEach(function (button) {
      var value = button.getAttribute('data-rr-bab-card-choice');
      button.setAttribute('aria-checked', value === mode ? 'true' : 'false');
    });

    if (this.cardFields) this.cardFields.hidden = mode !== 'with';
    this.cardInputs.forEach(this.updateCounter, this);
  };

  Builder.prototype.updateCounter = function (input) {
    var counter = input.parentNode
      ? input.parentNode.querySelector('[data-rr-bab-counter]')
      : null;
    if (!counter) return;
    var max = parseInt(input.getAttribute('maxlength'), 10) || 0;
    var remaining = Math.max(0, max - (input.value || '').length);
    counter.textContent = fill(this.strings.counter, { count: remaining });
    counter.classList.toggle('is-limit', remaining === 0);
  };

  Builder.prototype.cardLines = function () {
    var values = this.cardValues();
    return {
      to: values.to || '',
      lines: [values.line1 || '', values.line2 || '', values.line3 || ''],
      from: values.from || ''
    };
  };

  Builder.prototype.renderConfirm = function () {
    var self = this;

    if (this.confirmBox) {
      var box = this.state.boxKey ? this.boxes[this.state.boxKey] : null;
      this.confirmBox.textContent = box
        ? box.title + '　' + formatMoney(box.price, this.moneyFormat)
        : this.strings.boxNone || '';
    }

    if (this.confirmItems) {
      while (this.confirmItems.firstChild) {
        this.confirmItems.removeChild(this.confirmItems.firstChild);
      }
      this.filledSlots().forEach(function (key) {
        var entry = self.catalog[key];
        if (!entry) return;

        var item = document.createElement('li');
        item.className = 'rr-bab__summary-thumb';

        var media = document.createElement('span');
        media.className = 'rr-bab__summary-thumb-media';
        if (entry.image) {
          var image = document.createElement('img');
          image.src = entry.image;
          image.alt = '';
          image.loading = 'lazy';
          media.appendChild(image);
        }
        item.appendChild(media);

        var name = document.createElement('span');
        name.className = 'rr-bab__summary-thumb-name';
        name.textContent = entry.title;
        item.appendChild(name);

        self.confirmItems.appendChild(item);
      });
    }

    if (this.confirmCard) {
      if (this.state.cardMode === 'with') {
        var card = this.cardLines();
        var rows = [];
        if (card.to) rows.push(card.to);
        card.lines.forEach(function (line) {
          if (line) rows.push(line);
        });
        if (card.from) rows.push(card.from);
        this.confirmCard.textContent = rows.length ? rows.join('\n') : this.strings.cardNone || '';
      } else {
        this.confirmCard.textContent = this.strings.cardNone || '';
      }
    }

    if (this.confirmTotal) {
      this.confirmTotal.textContent = formatMoney(this.total(), this.moneyFormat);
    }
  };

  Builder.prototype.total = function () {
    var sum = 0;
    var box = this.state.boxKey ? this.boxes[this.state.boxKey] : null;
    if (box) sum += box.price;
    this.filledSlots().forEach(function (key) {
      var entry = this.catalog[key];
      if (entry) sum += entry.price;
    }, this);
    return sum;
  };

  Builder.prototype.renderTotal = function () {
    if (!this.totalNode) return;
    this.totalNode.textContent = formatMoney(this.total(), this.moneyFormat);
  };

  Builder.prototype.renderNav = function () {
    var step = this.state.step;
    var isLast = step >= this.lastStep;
    var satisfied = this.stepIsSatisfied(step);

    if (this.backButton) this.backButton.hidden = step <= 1;
    if (this.nextButton) {
      this.nextButton.hidden = isLast;
      this.nextButton.disabled = !satisfied;
    }
    if (this.submitButton) {
      this.submitButton.hidden = !isLast;
      this.submitButton.disabled = this.state.submitting || !this.canSubmit();
    }
    if (this.hintNode) {
      var hint = satisfied ? '' : this.stepHint(step);
      this.hintNode.textContent = hint;
      this.hintNode.hidden = !hint;
    }
  };

  Builder.prototype.canSubmit = function () {
    if (!this.stepIsSatisfied(1)) return false;
    if (!this.stepIsSatisfied(2)) return false;
    if (!this.stepIsSatisfied(3)) return false;
    return this.filledSlots().length > 0 || !!this.state.boxKey;
  };

  /* ---------- カート投入 ---------- */

  Builder.prototype.cardProperties = function () {
    var properties = { _gift_builder: 'yes' };

    if (this.state.cardMode !== 'with') {
      properties['_カード'] = this.strings.cardNoneProperty || 'なし';
      return properties;
    }

    var card = this.cardLines();
    if (card.to) properties['_カード宛名'] = card.to;
    card.lines.forEach(function (line, index) {
      if (line) properties['_カード本文' + (index + 1)] = line;
    });
    if (card.from) properties['_カード差出人'] = card.from;
    return properties;
  };

  Builder.prototype.buildItems = function (buildId) {
    var items = [];
    var cardProperties = this.cardProperties();
    var box = this.state.boxKey ? this.boxes[this.state.boxKey] : null;

    if (box && box.variantId) {
      var boxProperties = extend({}, cardProperties);
      boxProperties._gift_builder_id = buildId;
      boxProperties._gift_builder_role = 'box';
      /* カート1行化アプリが「畳んだあとの親」に使う目印。箱の行にだけ付ける */
      boxProperties._gift_role = 'box';
      items.push({ id: Number(box.variantId), quantity: 1, properties: boxProperties });
    }

    var counts = {};
    var order = [];
    this.filledSlots().forEach(function (key) {
      if (!counts[key]) {
        counts[key] = 0;
        order.push(key);
      }
      counts[key] += 1;
    });

    order.forEach(function (key) {
      var entry = this.catalog[key];
      if (!entry || !entry.variantId) return;
      var properties = { _gift_builder_id: buildId, _gift_builder_role: 'item' };
      /* 箱が未設定のときは、カード文言を先頭の商品に載せる（載せ先が無いと消えるため） */
      if (!box && items.length === 0) extend(properties, cardProperties);
      items.push({ id: Number(entry.variantId), quantity: counts[key], properties: properties });
    }, this);

    return items;
  };

  /* ---------- 投入に失敗したときの巻き戻し ---------- */

  Builder.prototype.cartJsUrl = function () {
    return this.config.cartJsUrl || (this.config.cartUrl || '/cart') + '.js';
  };

  Builder.prototype.cartUpdateUrl = function () {
    return this.config.cartUpdateUrl || (this.config.cartUrl || '/cart') + '/update.js';
  };

  /* Shopifyは在庫が足りないとき「入る分だけ入れて422」を返すことがある。
     画面が失敗を出しているのにカートには一部入っている状態を残さないため、
     カートを読み直し、この回の札が付いた明細を数量0にして取り消す。
     戻り値：'clean'（カートに残っていない）／'partial'（残っている可能性がある） */
  Builder.prototype.rollback = function (buildId) {
    var self = this;

    return fetch(this.cartJsUrl(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart_read_failed');
        return response.json();
      })
      .then(function (cart) {
        var updates = {};
        var found = 0;

        (cart.items || []).forEach(function (item) {
          var properties = item.properties || {};
          if (properties._gift_builder_id === buildId) {
            updates[item.key] = 0;
            found += 1;
          }
        });

        if (!found) return 'clean';

        return fetch(self.cartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        }).then(function (response) {
          if (!response.ok) throw new Error('cart_update_failed');
          return 'clean';
        });
      })
      .catch(function (error) {
        /* カートを読めない・取り消せないときは、入っていないと断定できない。
           安全側に倒して「入っているかもしれない」と伝える */
        if (window.console) window.console.warn('[rr-bab] カートの巻き戻しに失敗', error);
        return 'partial';
      });
  };

  Builder.prototype.submit = function () {
    if (this.state.submitting) return;
    if (!this.canSubmit()) return;

    var self = this;
    var buildId = makeBuildId();
    var items = this.buildItems(buildId);
    if (!items.length) {
      this.setError(this.strings.error || '');
      return;
    }

    this.state.submitting = true;
    this.setError('');
    if (this.submitButton) {
      this.submitButton.disabled = true;
      this.submitButton.setAttribute('aria-busy', 'true');
      this.submitButton.dataset.rrBabLabel = this.submitButton.textContent;
      if (this.strings.submitting) this.submitButton.textContent = this.strings.submitting;
    }

    fetch(this.config.cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            if (!response.ok) {
              var failure = new Error('cart_add_failed');
              /* APIの文言はお客様に出さない（英語が出る）。開発者向けにログへ回す */
              failure.apiMessage = data.description || data.message || '';
              failure.status = response.status;
              throw failure;
            }
            return data;
          });
      })
      .then(function () {
        window.location.href = self.config.cartUrl || '/cart';
      })
      .catch(function (error) {
        if (window.console) {
          window.console.warn(
            '[rr-bab] カートに追加できませんでした',
            (error && error.status) || '',
            (error && error.apiMessage) || (error && error.message) || error
          );
        }

        /* カートを照合し、入ってしまった分を取り消してから、ボタンを戻す */
        return self.rollback(buildId).then(function (result) {
          self.state.submitting = false;
          if (self.submitButton) {
            self.submitButton.removeAttribute('aria-busy');
            if (self.submitButton.dataset.rrBabLabel) {
              self.submitButton.textContent = self.submitButton.dataset.rrBabLabel;
            }
          }
          if (result === 'partial') {
            self.setError(self.strings.errorPartial || self.strings.error || '');
          } else {
            self.setError(self.strings.error || '');
          }
          self.renderNav();
        });
      });
  };

  /* ---------- 起動 ---------- */

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var roots = toArray(container.querySelectorAll('[data-rr-bab]'));

    if (scope && scope.matches && scope.matches('[data-rr-bab]')) roots.push(scope);

    roots.forEach(function (root) {
      if (root.dataset.rrBabReady === 'true') return;
      root.dataset.rrBabReady = 'true';
      new Builder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* テーマエディターでセクションを編集・追加したときの再起動 */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
